import { Link, useLocation } from "react-router"

export function NotFoundPage() {
  const { pathname, search } = useLocation()

  return (
    <div key={`${pathname}${search}`} className="animate-fade-in-up py-16 text-center">
      <p className="text-5xl font-bold">404</p>
      <p className="mt-2 text-sage-400">This page does not exist.</p>
      <Link to="/" className="mt-6 inline-block text-sm text-sage-300 underline underline-offset-4">
        Go home
      </Link>
    </div>
  )
}
